import actionCreator from '@/helpers/redux/actionCreator';

export const SET_FORMIK_PARAMETERS = '@/SET_FORMIK_PARAMETERS';

export const setFormikParameters = values => actionCreator(
  SET_FORMIK_PARAMETERS,
  { values },
);
